import { useCallback, useEffect, useState } from "react"
import { getTrackerByUserId } from "../../../utils/apis/tracker-service"
import { useAuth } from "../../../utils/context/AuthContext"
import { TrackingStatus } from "../../../utils/Enums"
import { handleDayOfMonth, handleDnaTrackerText, handleMonth, handleYear } from "../../../utils/Functions"

export const useGetDnaTracker = (patientId: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken
    const [isLoading, setIsLoading] = useState(true);
    const [dnaTracker, setDnaTracker] = useState<{ status: string | null; date: string | null }>({ status: null, date: null });
    const [dnaOrderId, setDnaOrderId] = useState("")
    const [dnaPickupDate, setDnaPickupDate] = useState<string | undefined>();

    const fetchDnaTracker = useCallback(() => {
        if (!patientId || !idToken) return;
        getTrackerByUserId(
            patientId,
            idToken,
            (trackers) => {
                if (trackers.length > 0) {
                    const tracker = trackers[0]
                    setDnaOrderId(tracker.order_id)
                    const statusText = handleDnaTrackerText(tracker.tracking_status)
                    const date = tracker.updated_at
                    const dateText = `${handleDayOfMonth(date)} ${handleMonth(date)} ${handleYear(date)}`
                    setDnaTracker({ status: statusText, date: dateText })
                    if (
                        [
                            TrackingStatus.PickupRequested,
                            TrackingStatus.Departed,
                            TrackingStatus.DeliveredToLaboratory,
                            TrackingStatus.StartingToExtract,
                            TrackingStatus.StartingAnalysis,
                            TrackingStatus.AnalysisDone,
                            TrackingStatus.ReportGenerated,
                        ].includes(tracker.tracking_status)
                    ) {
                        // Find the history entry for "pickup-requested"
                        const pickupEntry = tracker.tracking_history.find(
                            (entry) => entry.status === TrackingStatus.PickupRequested
                        );

                        if (pickupEntry) {
                            const date = pickupEntry.date;
                            setDnaPickupDate(`${handleDayOfMonth(date)} ${handleMonth(date)} ${handleYear(date)}`)
                        }
                    }
                }
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            }
        )
    }, [patientId, idToken]);

    useEffect(() => {
        fetchDnaTracker();
    }, [fetchDnaTracker]);

    return { dnaTracker, dnaPickupDate, isLoading, dnaOrderId, refetch: fetchDnaTracker };
}